import { render, staticRenderFns } from "./OriginAddressSearchBox.vue?vue&type=template&id=0e067550&"
import script from "./OriginAddressSearchBox.vue?vue&type=script&lang=js&"
export * from "./OriginAddressSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports